import { UserCircle } from 'lucide-react';
import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';

// Only components something actually resolves through the registry belong
// here. `LaunchFromPersonaDialog` and `PersonaPickerDialog` used to be listed
// and nothing ever asked for them: no `componentPath` in any plugin manifest
// names them, and their real consumers are plain ES imports —
// `AgentPersonasPage`/`AgentPersonaDetailPage` for the first,
// plugin-flows' `FlowPropertiesPanel` for the second. A registry entry
// nothing resolves is not free: Rollup sees a module both `import()`-ed
// and statically imported, gives up on isolating it, and says so —
//
//   (!) PersonaPickerDialog.tsx is dynamically imported by register.ts but
//       also statically imported by FlowPropertiesPanel.tsx,
//       dynamic import will not move module into another chunk.
//
// So the dead entries bought nothing and cost chunking. If a manifest surface
// ever needs one of them, add it back together with the `componentPath` that
// resolves it.
export default createWebRegistration({
  components: {
    '@reflex/plugin-agent-persona/web/AgentPersonasPage': () =>
      import('./AgentPersonasPage').then((m) => ({ default: m.AgentPersonasPage })),
    '@reflex/plugin-agent-persona/web/AgentPersonaDetailPage': () =>
      import('./AgentPersonaDetailPage').then((m) => ({ default: m.AgentPersonaDetailPage })),
    '@reflex/plugin-agent-persona/web/AgentPersonaFormPage': () =>
      import('./AgentPersonaFormPage').then((m) => ({ default: m.AgentPersonaFormPage })),
    '@reflex/plugin-agent-persona/web/SaveAsPersonaDialog': () =>
      import('./SaveAsPersonaDialog').then((m) => ({ default: m.SaveAsPersonaDialog })),
    '@reflex/plugin-agent-persona/web/PersonaSearchProvider': () =>
      import('./PersonaSearchProvider').then((m) => ({ default: m.PersonaSearchProvider })),
    '@reflex/plugin-agent-persona/web/PersonaMentionProvider': () =>
      import('./PersonaMentionProvider').then((m) => ({ default: m.PersonaMentionProvider })),
    '@reflex/plugin-agent-persona/web/PersonaMentionCreate': () =>
      import('./PersonaMentionCreate').then((m) => ({ default: m.PersonaMentionCreate })),
    '@reflex/plugin-agent-persona/web/PersonaMentionEdit': () =>
      import('./PersonaMentionEdit').then((m) => ({ default: m.PersonaMentionEdit })),
    '@reflex/plugin-agent-persona/web/PersonaPreview': () =>
      import('./PersonaPreview').then((m) => ({ default: m.PersonaPreview })),
    '@reflex/plugin-agent-persona/web/AgentPersonasPagePreview': () =>
      import('./AgentPersonasPagePreview').then((m) => ({
        default: m.AgentPersonasPagePreview,
      })),
  },
  icons: { UserCircle },
});
